// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'
import {useLocation} from 'react-router-dom'

// Components, services, etc
import LinkButton from 'components/LinkButton'
import {useSelector} from 'react-redux'

import OrderCard from 'components/OrderCard'
import OrderCardPlaceholder from 'components/OrderCardPlaceholder'
import {landingPageRecentOrdersSelector} from 'selectors'
import {handleMixpanelLaunchedProductEvent} from 'services/mixpanel'
import {getProductNavPath} from 'services/productNavigationServices'
import type {OpsOrderType} from 'types/orderTypes'
import {ALL_ORDERS_PATH} from 'constants/appRoutesConstants'

const LandingOrdersList = () => {
  const location = useLocation()
  const recentOrders = useSelector(landingPageRecentOrdersSelector)
  const recentOrdersPlaceholders = 4 - recentOrders.length
  const handleOrderClick = (order: OpsOrderType) => () => {
    handleMixpanelLaunchedProductEvent(location.pathname, order)
  }

  return (
    <LandingOrdersList.Styled>
      <div className='recent-orders-header'>
        <h3>Recent Orders</h3>
        <LinkButton variant='tertiary' title='All Properties →' to={ALL_ORDERS_PATH} />
      </div>
      <div className='cards-wrap'>
        <div className='inner'>
          {recentOrders.map(order => {
            const {created, productType, photoUrl, suppliedAddress = {}} = order
            return (
              <OrderCard
                key={order.opsOrderId}
                address={suppliedAddress}
                imageSrc={photoUrl}
                productType={productType}
                orderedDate={created}
                to={getProductNavPath(order)}
                onClick={handleOrderClick(order)}
              />
            )
          })}
          {recentOrdersPlaceholders > 0 &&
            Array.from(Array(recentOrdersPlaceholders)).map((placeholder, index) => (
              <OrderCardPlaceholder className='order-card' key={index} />
            ))}
        </div>
      </div>
    </LandingOrdersList.Styled>
  )
}

LandingOrdersList.Styled = styled.div`
  max-width: 1440px;
  padding: 40px 0 60px 80px;
  margin-left: auto;
  margin-right: auto;

  .recent-orders-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: space-between;
    padding-right: 80px;
    margin-right: -80px;
    width: 100%;

    h3 {
      margin-bottom: 0;
    }
  }

  .cards-wrap {
    display: flex;
    overflow-x: auto;
    padding: 10px;
    margin: -10px;
    min-height: 236px;

    .inner {
      display: flex;
      .order-card {
        flex: none;

        & + .order-card {
          margin-left: 16px;
        }
      }
    }
  }

  @media (max-width: 1360px) {
    .inner {
      /* 1280 (width of content) + 80px (padding-left) */
      min-width: 1360px;
    }
  }

  @media (max-width: 1024px) {
    .recent-orders-header {
      padding-right: 40px;
      margin-right: -40px;
    }
    padding-left: 40px;
    .inner {
      /* 1280 (width of content) + 40px (padding-left) */
      min-width: 1320px;
    }
  }
`

export default LandingOrdersList
